import { Record, Map as IMap } from "immutable";
import Person from "./Person";
import Company from "./Company";

export const CLIENT_TYPES = {
  PERSON: "PERSON",
  COMPANY: "COMPANY",
};

export const CLIENT_TYPE_PREFIXES = {
  PERSON: "p-",
  COMPANY: "c-",
};

export const CLIENT_TYPE_DATA_TYPES = {
  PERSON: Person,
  COMPANY: Company,
};

const Client = new Record({
  id: null,
  remoteId: null,
  type: null,
  privileges: new IMap(),
  data: null,
});

export const getClientId = ({ remoteId, type }) => {
  return CLIENT_TYPE_PREFIXES[type] + remoteId;
};

export const getClientDataRecord = ({ type }) => {
  return CLIENT_TYPE_DATA_TYPES[type];
};

export default Client;



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/schema/Client.js